import React from 'react';
import { Grid } from 'semantic-ui-react';
function EmptyCartMessage() {
  return /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement(Grid.Row, null, /*#__PURE__*/React.createElement("div", {
    className: "cart-summary-empty"
  }, "No items in your cart")));
}
export default EmptyCartMessage;